export const CASHOUT_STATUS = {
  Requested: 'requested',
  Processing: 'processing',
  Ready: 'ready',
  Failed: 'failed',
} as const;
export type CashoutStatus = (typeof CASHOUT_STATUS)[keyof typeof CASHOUT_STATUS];

export interface CashOut {
  id: number;
  amount_cents: number;
  status: CashoutStatus;
  tremendous_order_id: string | null;
  tremendous_reward_id: string | null;
  tremendous_url_expires_at: string | null;
  requested_at: string | null;
  failed_at: string | null;
  failure_reason: string | null;
  created_at: string;
}

export interface CashOutResponse {
  cash_out: CashOut;
}

export interface CashOutListResponse {
  cash_outs: CashOut[];
}

export interface RedemptionLinkResponse {
  redemption_url: string;
}
